// Dekad arithmetic for the reporting page. Dekads run (month, 01) → (month, 11)
// → (month, 21); the dekad before (month, 01) is (month - 1, 21), wrapping to
// December of the previous year for January. Mirrors `previous_dekad()` in
// data_api/api/handle_reporting.py.

function pad2(n) {
  return String(n).padStart(2, "0");
}

/**
 * @param {{year: string|number, monthInt: string|number, dekad: string|number}} step
 * @returns {{year: number, monthInt: string, dekad: string}} the dekad before `step`
 */
export function previousDekad({ year, monthInt, dekad }) {
  const y = Number(year);
  const m = Number(monthInt);
  const d = pad2(dekad);

  if (d === "21") return { year: y, monthInt: pad2(m), dekad: "11" };
  if (d === "11") return { year: y, monthInt: pad2(m), dekad: "01" };
  if (m === 1) return { year: y - 1, monthInt: "12", dekad: "21" };
  return { year: y, monthInt: pad2(m - 1), dekad: "21" };
}

/**
 * The calendar month before `{year, monthInt}`. January wraps to December of
 * the previous year. Used for the GPCC SPI map, which lags the analysis
 * period by one month.
 *
 * @param {{year: string|number, monthInt: string|number}} step
 * @returns {{year: number, monthInt: string}}
 */
export function previousMonth({ year, monthInt }) {
  const y = Number(year);
  const m = Number(monthInt);
  if (m === 1) return { year: y - 1, monthInt: "12" };
  return { year: y, monthInt: pad2(m - 1) };
}

/**
 * @param {{year: string|number, monthInt: string|number, dekad?: string|number}} step
 * @returns {string} ISO-ish date, e.g. "2026-07-21" or "2026-07"
 */
export function formatDekadDate({ year, monthInt, dekad }) {
  const base = `${year}-${pad2(monthInt)}`;
  return dekad == null ? base : `${base}-${pad2(dekad)}`;
}
